import http from './http';

const getPages = (value, page) => {
  const q = value && value.length > 0 ? `&query=${encodeURIComponent(value)}` : '';
  return http.get(`/page/list?page_size=10&page_nbr=${page}&sort_field=created_at&sort_type=desc&empty=true${q}`);
};

export default { getPages };
export { getPages };
